import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

import './home.css';
import './headerMenu.css';

import footerLogo from '../assets/images/logo/footerLogo.png';
import { getActiveMenu } from '../utils/utils';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [header, setHeader] = useState(false);
    const [isNavExpanded, setIsNavExpanded] = useState(false);
    const [helpCenterMenuVisible, setHelpCenterMenuVisible] = useState(true);
    const [activeMenu, setActiveMenu] = useState('');

    useEffect(() => {
        const changeBackground = () => {
            if (window.scrollY >= 90) {
                setHeader(true);
            } else {
                setHeader(false);
            }
        };

        window.addEventListener('scroll', changeBackground);
        return () => {
            window.removeEventListener('scroll', changeBackground);
        };
    }, []);

    useEffect(() => {
        const path = location.pathname;
        
        setActiveMenu(getActiveMenu(path));
    }, [location.pathname]);

    const handleLinkClick = (url) => {
        // setHelpCenterMenuVisible(false);
        setIsNavExpanded(false);
        setActiveMenu(url);
        navigate(url);
    };

    return (
        <>
            {/* <!-- ======= Header ======= --> */}
            {/* <header className="header fixed-top"> */}
            <header className={header ? 'header fixed-top' : 'header'}>
                <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
                    <Link to="/" className="logo d-flex align-items-center">
                        <img src={footerLogo} alt="" />
                    </Link>

                    <nav className={isNavExpanded ? 'navbar-mobile' : 'navbar'} id="navbar">
                        {/* <nav className="navbar-mobile navbar" id="navbar"> */}
                        <ul>
                            <li className={`${activeMenu === '/solution' ? 'active-menu' : ''}`}>
                                <NavLink to="/solution" onClick={() => handleLinkClick('/solution')}>Solution</NavLink>
                            </li> 
                            
                            <li className={`${activeMenu === '/service' ? 'active-menu' : ''}`}>
                                <NavLink to="/service" onClick={() => handleLinkClick('/service')}>Service</NavLink>
                            </li> 

                            <li>
                                <NavLink to="/portfolio" onClick={() => handleLinkClick('/portfolio')}>Portfolio</NavLink>
                            </li>                            
                            
                            <li className={`${activeMenu === '/company' ? 'active-menu' : ''}`}>
                                <NavLink to="/company" onClick={() => handleLinkClick('/company')}>Company</NavLink>
                            </li> 

                            <li className={` dropdown help-center ${activeMenu === '/help-center' ? 'active' : ''}`}
                                // onMouseEnter={() => setHelpCenterMenuVisible(true)}
                                // onMouseLeave={() => setHelpCenterMenuVisible(true)}
                            >
                                <NavLink to="/help-center" onClick={(e) => {
                                    e.preventDefault();
                                    setHelpCenterMenuVisible(prev => !prev)
                                    // handleLinkClick('help-center');
                                }}>
                                    <span>Help Center</span> <i className="bi bi-chevron-down"></i>
                                </NavLink>
                                <ul className={helpCenterMenuVisible ? '' : 'd-none'}>
                                    <Link to="knowledged-base" onClick={() => setIsNavExpanded(false)}> Knowledged Base </Link>
                                    <Link to="contact-us" onClick={() => setIsNavExpanded(false)}> Contact Us</Link>
                                </ul>
                            </li>
                        </ul>

                        <i
                            onClick={() => {
                                setIsNavExpanded(!isNavExpanded)
                            }}
                            className={isNavExpanded ? 'bi bi-x-circle mobile-nav-toggle' : 'bi bi-list mobile-nav-toggle'}
                        ></i>

                    </nav>
                </div>
            </header>
        </>
    );
};

export default Header;